import { createFileRoute } from '@tanstack/react-router';
import { Package } from '@/core/ui/icons';
import { ComingSoon } from '@/core/ui';

export const Route = createFileRoute('/_app/pedidos')({
  component: () => (
    <ComingSoon
      title="Pedidos"
      description="Acompanhe os seus pedidos e o histórico de compras."
      icon={Package}
    />
  ),
});
